<template>
    <b-row>
        <b-col cols="12">
            <h2 class="m-0 h1 text-uppercase">
                {{ $t('perfil_invitaciones.selecciona_zona') }}
            </h2>
        </b-col>
        <b-col cols="12">
            <transition name="fade" mode="out-in">
                <div class="row" key="zonas" id="zonas">
                    <div class="col-lg-8">
                        <h3 class="subtitle h3 light mb-3">{{ $t('partido.pinchando_mapa') }}:</h3>
                        <ContentOrLoading>
                            <div class="lightgray-content" v-if="!loading">
                                <SvgComponent
                                    v-if="place"
                                    :zonas="zonas"
                                    :place="place" 
                                    :sesion_id="sesion_id"
                                    @clickZona="finalizarPasoUno"
                                    @cargado="onMapaCargado"
                                />
                            </div>
                        </ContentOrLoading>
                    </div>
                    <div class="col-12 col-lg-4" v-if="isMapaCargado">
                        <h3 class="subtitle h3 light mb-3"> {{ $t('partido.tabla') }}:</h3>
                        <div class="lightgray-content p-2 pb-0" id="tabla-sectores">
                            <ContentOrLoading style="min-height: 400px;">
                                <TablaSectoresComponent v-if="zonas?.length" :zonas="zonas" v-on:goTo="finalizarPasoUno"/>
                            </ContentOrLoading>                                    
                        </div>
                    </div>
                </div>
            </transition>
        </b-col>
    </b-row>
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';
    import TablaSectoresComponent from '@/components/frontend/events/compra/TablaSectoresComponent';

    export default {
        props: {
            event_id: {
                type: [String, Number],
                required: true
            },
            sesion_id: {
                type: [String, Number],
                required: true
            },
            abono_id: {
                type: [String, Number],
                required: true
            },
            place: {
                type: Object,
                required: true
            },
            frontend: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                zonas: [],
                loading: false,
                isMapaCargado: false
            } 
        },
        methods: {
            onMapaCargado() {
                this.isMapaCargado = true;
                this.loading = false;
            },
            finalizarPasoUno(zona) {
                this.$emit('terminado', zona);
            },
            getZonas() {
                this.loading = true;
                const params = {
                    abonado_id: this.abono_id,
                    evento_id: this.event_id,
                    sesion_id: this.sesion_id,
                }
                const alias = this.frontend
                    ? 'front.perfil.invitaciones.zonas'
                    : 'back.abonados.abono.invitaciones-zonas';
                this.$store.dispatch(this.config.getVuexAlias(alias), params).then(res => {
                    this.zonas = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        created() {
            this.getZonas();
        },
        components: {
            SvgComponent, TablaSectoresComponent
        }
    }
</script>